// Set by .env.development in local
export const FIREADMIN_URL = process.env.FIREADMIN_URL || 'https://fireadmin.io'
